import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';

interface ApplicationMemoModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (memo: string) => void;
  memo: string | null;
  isSubmitting?: boolean;
}

export default function ApplicationMemoModal({
  open,
  onClose,
  onSave,
  memo,
  isSubmitting = false,
}: ApplicationMemoModalProps) {
  const [value, setValue] = useState(memo ?? '');

  useEffect(() => {
    if (open) {
      setValue(memo ?? '');
    }
  }, [open, memo]);

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-[620px] rounded">
        <DialogHeader className="items-start space-y-0 px-lg! py-md!">
          <DialogTitle className="text-base font-bold">社内メモ</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-xs p-lg">
          <textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="入力してください"
            rows={9}
            className="w-full rounded border border-solid border-border p-sm text-body-sm outline-hidden focus:border-primary"
          />
          <p className="text-body-xs text-sub">社内メモは、アライアンス先には共有されません。</p>
        </div>

        <DialogFooter className="justify-end gap-md px-lg! py-md!">
          <Button color="secondary" size="md" onClick={onClose} disabled={isSubmitting}>
            キャンセル
          </Button>
          <Button
            color="primary"
            size="md"
            onClick={() => onSave(value)}
            disabled={value === (memo ?? '') || isSubmitting}
          >
            {isSubmitting ? '保存中...' : '完了'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
